<div class="UpcomingWrapper">

   <div class="partTop">
        <div class="label">
            Previous Bookings
        </div>
    </div>
    <!-- <div class="title" *ngIf="authService.profile?.previousBookings?.length">
        <div class="label">Previous Bookings</div>
    </div> -->
    <div class="title" *ngIf="authService.profile?.previousBookings?.length == 0">
        <div class="label">No Previous Bookings</div>
    </div>
    <div class="list" *ngIf="authService.profile?.previousBookings?.length">
        <app-booking-card [booking]="booking" *ngFor="let booking of authService.profile?.previousBookings"></app-booking-card>
    </div>
</div>